import React from 'react';
import Icon from '../../../components/AppIcon';

const NotificationStatsPanel = ({ stats }) => {
  if (!stats) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Chargement des statistiques...</p>
      </div>
    );
  }

  const getTypeLabel = (type) => {
    const labels = {
      inventory_alert: 'Alertes Stock',
      schedule_assignment: 'Assignations Mission',
      schedule_reminder: 'Rappels Mission',
      urgent_alert: 'Alertes Urgentes',
      general: 'Général',
    };
    return labels?.[type] || type;
  };

  const getTypeIcon = (type) => {
    const icons = {
      inventory_alert: 'Package',
      schedule_assignment: 'Calendar',
      schedule_reminder: 'Clock',
      urgent_alert: 'AlertTriangle',
      general: 'Mail',
    };
    return icons?.[type] || 'Mail';
  };

  const calculateSuccessRate = (sent, total) => {
    if (total === 0) return 0;
    return ((sent / total) * 100)?.toFixed(1);
  };

  return (
    <div className="space-y-6">
      {/* Overall Stats */}
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-4">Vue d'ensemble (7 derniers jours)</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-muted/30 rounded-lg p-6 border border-border">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                <Icon name="Mail" size={24} className="text-primary" />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Total Notifications</p>
                <p className="text-3xl font-bold text-foreground">{stats?.total || 0}</p>
              </div>
            </div>
          </div>

          <div className="bg-muted/30 rounded-lg p-6 border border-border">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 rounded-lg bg-success/10 flex items-center justify-center">
                <Icon name="CheckCircle" size={24} className="text-success" />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Taux de Réussite</p>
                <p className="text-3xl font-bold text-success">
                  {calculateSuccessRate(stats?.sent, stats?.total)}%
                </p>
              </div>
            </div>
          </div>

          <div className="bg-muted/30 rounded-lg p-6 border border-border">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 rounded-lg bg-error/10 flex items-center justify-center">
                <Icon name="XCircle" size={24} className="text-error" />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Échecs</p>
                <p className="text-3xl font-bold text-error">{stats?.failed || 0}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* By Type Stats */}
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-4">Statistiques par Type</h3>
        <div className="space-y-3">
          {Object.entries(stats?.byType || {})?.map(([type, typeStats]) => (
            <div
              key={type}
              className="bg-muted/30 rounded-lg p-4 border border-border"
            >
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name={getTypeIcon(type)} size={20} className="text-primary" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-medium text-foreground">{getTypeLabel(type)}</span>
                    <span className="text-sm text-muted-foreground">
                      {typeStats?.total || 0} notifications
                    </span>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="flex-1 bg-muted rounded-full h-2 overflow-hidden">
                      <div
                        className="bg-success h-full transition-all duration-300"
                        style={{
                          width: `${calculateSuccessRate(typeStats?.sent, typeStats?.total)}%`,
                        }}
                      />
                    </div>
                    <div className="flex items-center gap-3 text-xs">
                      <span className="text-success">
                        <Icon name="CheckCircle" size={14} className="inline mr-1" />
                        {typeStats?.sent || 0}
                      </span>
                      <span className="text-error">
                        <Icon name="XCircle" size={14} className="inline mr-1" />
                        {typeStats?.failed || 0}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {Object.keys(stats?.byType || {})?.length === 0 && (
            <div className="text-center py-8">
              <Icon name="Inbox" size={48} className="text-muted-foreground mx-auto mb-4" />
              <p className="text-muted-foreground">Aucune statistique disponible</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationStatsPanel;